class TokenService {
  getLocalRefreshToken() {
    
    return localStorage.getItem("refreshToken");
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.accessToken;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
    if (user.organization == null)
      localStorage.removeItem("organization");
  }

  removeUser() {
    localStorage.removeItem("user");
  }

  removeRefreshToken() {
    localStorage.removeItem("refreshToken");
  }

  removeOrganization() {
    localStorage.removeItem("organization");
  }
}

export default new TokenService();